/* eslint-disable no-unused-vars */
import angular from 'angular';
import template from './templates/autocomplete-multiselect-kt.tmpl.html';

export default function AutocompleteMultiselect() {
    'ngInject';
    return {
        restrict: 'AE',
        template,
        bindToController: true,
        controller: AutocompleteMultiselectController,
        scope: {
            model: '=model',
            caption: '&',
            dosearch: '&',
            dochange: '&',
        },
        link: function($scope, elem, attr) {
            $scope.tooltipProperty = attr.tooltipProperty;
            $scope.displayProperty = attr.displayProperty;
            $scope.id = attr.details;
            $scope.name = attr.name;
            $scope.isRequired = attr.required === '' || attr.required === 'true' || attr.required === true;
            $scope.placeholder = attr.placeholder;
            $scope.tabindex = attr.tabindexorder;
            $scope.searchFilter = '';
        },
    };

    function AutocompleteMultiselectController(
        $scope,
        $element,
    ) {
        'ngInject';

        const input = $element.find('input');

        const container = $element.find('.control-container');
        container.on('click', function() {
            input.focus();
            adjustWidth();
        });

        angular.extend($scope, {
            chooseItem,
            removeItem,
            getDisplayValue,
            getTooltipValue,
            filter,
            clickOutside,
        });

        function adjustWidth() {
            const contWidth = container.width();
            const items = container.find('.added-item-container');
            let total = 0;
            for (let index = 0; index < items.length; index++) {
                const elem = items[index];
                total += angular.element(elem).width() + 6;
                if (contWidth - total <= 60) {
                    total = 0;
                }
            }
            input.closest('li').width(contWidth - total - 4);
            container.addClass('bordered');
        }

        function clickOutside() {
            container.removeClass('bordered');
            // input.closest('li').width(3);
        }

        function getDisplayValue(item, length) {
            if (!$scope.displayProperty && !$scope.tooltipProperty) {
                return '';
            }
            return length === 1 ? item[$scope.tooltipProperty] : item[$scope.displayProperty];
        }

        function getTooltipValue(item) {
            if (!$scope.tooltipProperty) {
                return null;
            }
            return item[$scope.tooltipProperty];
        }

        function chooseItem($item) {
            $scope.searchFilter = '';
            if ($scope.model.map((mitem) => mitem[$scope.displayProperty]).indexOf($item[$scope.displayProperty]) !== -1) {
                return;
            }
            $scope.model.push($item);
            if ($scope.dochange) {
                $scope.dochange();
            }
        }

        function removeItem(item) {
            if ($scope.model !== null && $scope.model !== '') {
                const itemIndex = $scope.model.indexOf(item);
                if (itemIndex !== -1) {
                    $scope.model.splice(itemIndex, 1);
                    if ($scope.dochange) {
                        $scope.dochange();
                    }
                }
            }
        }

        function filter(searchFilter) {
            return $scope.dosearch()(searchFilter);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/directives/autocomplete-multiselect-kt.directive.js